'use client';

import React__default from 'react';
import Skeleton from '../../Skeleton/index.js';
import { User, AvatarUser, CircleSkeleton, UserInfo, SkeletonContainer } from '../Styled.css.js';

var UserInfoSkeleton = function () {
    return (React__default.createElement(User, null,
        React__default.createElement(AvatarUser, null,
            React__default.createElement(CircleSkeleton, { width: 88, height: 88 })),
        React__default.createElement(UserInfo, null,
            React__default.createElement(Skeleton, { height: 44 }),
            React__default.createElement(Skeleton, { height: 44 }))));
};
var JobInfoSkeletion = function () {
    return (React__default.createElement(SkeletonContainer, null,
        React__default.createElement(Skeleton, { height: 16, width: 300 }),
        React__default.createElement(Skeleton, { height: 72 }),
        React__default.createElement(Skeleton, { height: 72 }),
        React__default.createElement(Skeleton, { height: 16, width: 250 }),
        React__default.createElement(Skeleton, { height: 14 }),
        React__default.createElement(Skeleton, { height: 14 })));
};

export { JobInfoSkeletion, UserInfoSkeleton };
//# sourceMappingURL=Skeletion.js.map
